import { useEffect } from "react";
import { IoArrowBackCircleSharp } from "react-icons/io5";

const NewsPanel = ({ date, title, img, text, isOpen, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Modify text: Add <br /> before every <strong> tag
  const formattedText = text?.replace(/<strong>/g, "<br /><strong>");

  return (
    // backdrop
    <div
      className={`fixed inset-0 bg-blue bg-opacity-95 flex justify-end z-50 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={onClose}
    >
      {/* text area */}
      <div
        className={`bg-white h-full p-8 shadow-lg transition-transform duration-300 transform w-full md:w-[40%] relative font-tenor text-blue overflow-y-auto ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="mb-2 text-xs text-gray-800 underline">{date}</p>
        <p className="mb-2 font-bold text-lg">{title}</p>
        <div className="overflow-hidden w-full mb-2">
          {Array.isArray(img) ? (
  <img
    className="transition-transform duration-500 ease-in-out hover:scale-105"
    src={img[1] || img[0]}
    alt=""
  />
) : (
  <img
    className="transition-transform duration-500 ease-in-out hover:scale-105"
    src={img}
    alt=""
  />
)}

        </div>
        <div
          className="mb-20 md:mb-0 text-base"
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </div>

      {/* mobile back arrow */}
      <div className="md:hidden absolute bottom-0 left-0 right-0 py-14 bg-white"></div>
      <div className="absolute bottom-0 left-0 right-0 bg-white mx-8 py-6 md:hidden z-10 border-t-[1px] border-blue">
        <button
          className="text-blue text-3xl md:hidden hover:text-yellow flex items-center gap-2"
          onClick={onClose}
        >
          <IoArrowBackCircleSharp className="hover:scale-125" />
          <span className="text-lg">BACK</span>
        </button>
      </div>
    </div>
  );
};

export default NewsPanel;
